function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Y from 'yjs';
import { ElementModel } from './ElementModel';
import { EditorConfig } from '../../edit/EditorConfig';
import { removeObserver } from '@netless/forge-room';
export class PointTextModel extends ElementModel {
  set content(value) {
    this.root.set('content', value);
  }
  get content() {
    return this.root.get('content');
  }
  get fontSize() {
    return this.root.get('font-size');
  }
  set fontSize(value) {
    this.root.set('font-size', value);
  }
  get fontFamily() {
    return this.root.get('font-family');
  }
  set fontFamily(value) {
    this.root.set('font-family', value);
  }
  get drawPoints() {
    if (this.localPoints.length > 1) {
      return this.localPoints;
    }
    return this.points;
  }
  constructor(root, scope, liveCursor, isPerformanceMode) {
    super(root, scope, liveCursor, isPerformanceMode);
    _defineProperty(this, "item", null);
    _defineProperty(this, "clearLocalPointsWhenYPointsChange", true);
    _defineProperty(this, "shouldUseLocalPoints", false);
    _defineProperty(this, "localPointsPick", 2);
    _defineProperty(this, "handleTextPropChange", event => {
      if (!this.item) {
        return;
      }
      for (const [key, value] of event.changes.keys.entries()) {
        if (value.action === 'update' || value.action === 'add') {
          if (key === 'content') {
            this.item.content = this.root.get('content') ?? '';
            this.updateTextPosition();
          } else if (key === 'font-size') {
            this.item.fontSize = this.fontSize;
            this.updateTextPosition();
          }
        }
      }
    });
    if (this.root.doc && !this.root.has('type')) {
      this.root.set('type', 'point-text');
    }
    if (this.root.doc && !this.root.has(ElementModel.KEYS.points)) {
      this.root.set(ElementModel.KEYS.points, new Y.Array());
    }
    this.root.observe(this.handleTextPropChange);
    setTimeout(() => {
      if (this.root && this.root.has('font-size')) {
        setTimeout(() => {
          this.updateTextPosition();
        }, 60);
      }
    }, 60);
  }
  subDispose() {
    removeObserver(this.root, this.handleTextPropChange);
  }
  subBindObserver() {
    removeObserver(this.root, this.handleTextPropChange);
    this.root.observe(this.handleTextPropChange);
  }
  liveCursorPoint() {
    const points = this.points;
    if (points.length < 1) {
      return null;
    }
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    // 字体框左上角
    const topLeft = new this.scope.Point(points[0], points[1]).transform(matrix);
    return topLeft;
  }
  getInternalMeasurement() {
    if (!this.item) {
      return null;
    }
    const bounds = this.item.internalBounds;
    const matrix = new this.scope.Matrix(this.pointsMatrix);
    // 字体框左上角
    const topLeft = new this.scope.Point(this.drawPoints[0], this.drawPoints[1]).transform(matrix);
    // 字体框右上角
    const topRight = new this.scope.Point(this.drawPoints[0] + bounds.width, this.drawPoints[1]).transform(matrix);
    let scaleX = topRight.getDistance(topLeft) / bounds.width;
    scaleX = Number.isNaN(scaleX) ? 1 : scaleX;
    const angle = topRight.subtract(topLeft).angle;
    return {
      scaleX,
      topLeft,
      topRight,
      angle,
      bounds
    };
  }
  updateTextPosition() {
    const measurement = this.getInternalMeasurement();
    if (!this.item || !measurement) {
      return;
    }
    const {
      scaleX,
      topLeft,
      angle,
      bounds
    } = measurement;
    const fontSize = this.fontSize * scaleX;
    this.item.position.x = topLeft.x + bounds.width / 2;
    this.item.position.y = topLeft.y + bounds.height / 2;
    this.item.rotation = 0;
    this.item.fontSize = fontSize;
    this.item.rotate(angle, [topLeft.x, topLeft.y]);
  }
  editorConfig() {
    const cfg = new EditorConfig();
    cfg.resizeModel = () => 'horizontal';
    cfg.uniformScale = () => true;
    return cfg;
  }
  createPaperItem() {
    this.item = new this.scope.PointText(new this.scope.Point(0, 0));
    this.item.content = this.content || '';
    this.item.strokeColor = new this.scope.Color(this.strokeColor);
    this.item.fillColor = new this.scope.Color(this.strokeColor);
    this.item.fontFamily = this.fontFamily;
    this.item.fontSize = this.fontSize;
    this.updateTextPosition();
  }
  onVectorUpdate() {
    this.updateTextPosition();
  }
  vectorKeys() {
    return [];
  }
  styleKeys() {
    return {
      include: ['fontSize', 'fontFamily', 'strokeColor'],
      exclude: ['fillColor', 'dashArray']
    };
  }
  onStyleKeyUpdate(key) {
    if (!this.item) {
      return;
    }
    if (key === 'strokeColor') {
      this.item.strokeColor = new this.scope.Color(this.strokeColor);
      this.item.fillColor = new this.scope.Color(this.strokeColor);
    }
  }
}